<template>
  <button class="keyword-planner-action-button" v-on="$listeners">
    {{ $t('ADVERTISEMENT.KEYWORDPLANNER.SELECT_ACTION') }}
    <i class="el-icon-arrow-down keyword-planner-action-button__icon" />
  </button>
</template>

<script>
export default {
  name: 'KeywordPlannerActionButton',
};
</script>

<style lang="scss">
.keyword-planner-action-button {
  cursor: pointer;
  color: #fff;
  min-width: $--input-width;
  height: $--input-height;
  border: $--input-border;
  border-color: $--input-border-color;
  border-radius: $--input-border-radius;
  padding: 0 $global-padding / 1.6;

  &::placeholder {
    color: $--input-placeholder-color;
  }

  &:focus {
    outline: none;
  }

  &__icon {
    margin-right: calc($global-margin / 2);
  }
}
</style>
